/* eslint-disable */
import  CryptoJS from 'crypto-js'
import axios from 'axios'
import Cookies from 'js-cookie'
// import PostcsUrl from 'postcss-url'
//export default {
  // name: 'P1'
  // 数字最大长度
var countToLogin = 0
 let numMaxLength = function (value, maxLength, func) {
    var isValid = /^\d+$/.test(value)
    var rvalue = ''
    if (isValid) {
      rvalue = value.substring(0, maxLength)
    } else {
      rvalue = ''
    }
    // console.log(rvalue)
    if (func !== undefined) {
      func(rvalue)
    }
  }
  let encryptData = function(data, key1) {
   // const bytes = CryptoJS.AES.encrypt(data, key);
   // return bytes.toString();
    const key = CryptoJS.enc.Utf8.parse(key1) // 加密密钥，必须为16位
    //const iv = CryptoJS.enc.Utf8.parse(key1) // 偏移量，必须为16位
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv: key,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    const encryptedStr = encrypted.ciphertext.toString(CryptoJS.enc.Hex)
    return encryptedStr
  }
let decryptData = function(data, key1) {
  const key = CryptoJS.enc.Utf8.parse(key1) // 加密密钥，必须为16位
  //const iv = CryptoJS.enc.Utf8.parse(key1) // 偏移量，必须为16位
  const decrypted = CryptoJS.AES.decrypt(data, key, {
    //iv: iv,
    iv: key,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  const decryptedStr = decrypted.ciphertext.toString(CryptoJS.enc.Hex)
  return decryptedStr
}
//显示错误或者成功弹框信息
let showMessage = function (selfthis,type,message){
  selfthis.$message({
    message: message,
    type: type,
    showClose: true,
    offset: 200,
    duration:1500
  });
}
let genAuthorization = function (){
  var Authorization = ""
  var token = Cookies.get('token');
  if(token){
    Authorization = "token "+token
  }
  return Authorization
}
let toLogin = function (selfthis,msg){
  //防止一个页面多个ajax请求，弹出登录页面
  if(countToLogin>0) return true;
   countToLogin= countToLogin+1
   console.log("退出登录:"+msg)
   showMessage(selfthis,'warning',"登录失效，需要重新登录")
   setTimeout("window.location.href = '/'",500)
   return true
}
let ajaxPost = function(selfthis,url,data,func,errorfunc){
    var Authorization = genAuthorization()
    axios.post(url,data,{headers: {'Content-type':'application/x-www-form-urlencoded;charset=utf-8','Authorization':Authorization}}).then(function(res){
      console.log(res.data)
      if(res.data.code ==1000){
        if(func!=undefined) func(selfthis,res.data.data)
        // selfthis.$message({
        //    message: '提交成功！',
        //    type: 'success'
        //  });
      }else if(res.data.code=='4001'){//需要重新登录
        toLogin(selfthis,res.data.msg)
      }else{
        var message=res.data.msg
        console.log("返回错误信息:"+message)
        if(errorfunc!=undefined) errorfunc(selfthis,res.data)
        else{
          commfun.showMessage(selfthis,'warning',"错误信息："+message)
        }
      }

    }).catch(function (error) {
      // selfthis.$message({
      //          message: "网络异常:"+url,
      //          type: 'warning'
      //         });
      console.log("网络异常errorurl:"+url)
      console.log(error)

    });

}//end ajaxPost
let ajaxGet = function(selfthis,url,params,func,errorfunc){
  var selfthis=selfthis
  if(params==undefined) params=[]
  var Authorization = genAuthorization()
  axios({
    headers: {'Authorization':Authorization},
    method:'get',
    url:url,
    params:params,

  }).then(function(res){
    // console.log(res.data)
    if(res.data.code=='1000'){
      if(func!=undefined) func(selfthis,res.data.data)

    }else if(res.data.code=='4001'){//需要重新登录
       toLogin(selfthis,res.data.msg)
    }else{
      console.log("get 返回错误信息:")
      console.log(res)
      var message=res.data.msg
      if(errorfunc!=undefined) errorfunc(selfthis,res.data)
      else{
        commfun.showMessage(selfthis,'warning',"错误信息："+message)

      }

    }

  }).catch(function (error) {
    // selfthis.$message({
    //              message: "网络异常:"+url,
    //              type: 'warning'
    //             });
    console.log("errorurl:"+url)
    console.log(error)
  });
}
let ajaxOnline = function(selfthis){//online check
  ajaxGet(selfthis,'/api/api/user/online',{},function(selfthis,data){})
}

let inArray = function (search, array) {
    for (var i = 0; i < array.length; i++) {
        if (array[i] === search) {
            return true;
        }
    }
    return false;
}

export { numMaxLength,encryptData,decryptData,showMessage,ajaxPost,ajaxGet,ajaxOnline,genAuthorization, inArray}



// WEBPACK FOOTER //
// ./src/common/common.js